import APIClient from './index';
import _ from 'lodash';

const get = path =>
  new Promise((resolve, reject) => {
    APIClient.get(path)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });

export const searchShopMyDmCreators = q => get(`AdminSmartDm/creators?q=${encodeURIComponent(q)}`);

export const getShopMyDmCreator = User_id => get(`AdminSmartDm/creators/${User_id}`);

export const getShopMyDmSends = (User_id, { range, status, kind, page }) => {
  const params = new URLSearchParams({ range, status, kind, page: String(page) });
  return get(`AdminSmartDm/creators/${User_id}/sends?${params}`);
};

export const getShopMyDmSummary = range => get(`AdminSmartDm/summary?range=${encodeURIComponent(range)}`);

export const getShopMyDmStatus = () => get('AdminSmartDm/status');
